import * as Energy from './types/Energy.js';

export const DEFAULT_INVOKE_ENERGY: Energy.Type = Energy.create(1000000n);
export const MAX_U64 = 18446744073709551615n; // 2n ** 64n - 1n
export const MAX_U8 = 255; // 2 ** 8 - 1
